module.exports = __webpack_public_path__ + "static/media/heroimage_igib-003.7319728c.jpg";